// AMC Management Types

export interface AMC {
  visitId: string;
  state: string;
  locationCode: string;
  oldLocationCode: string;
  visitPeriod: string; // Q1, Q2, Q3, Q4
  visitDate: string; // YYYY-MM-DD
  reportNo: string;
  nextVisitDate: string; // YYYY-MM-DD
  visitedBy: string; // User ID
  visitedByName?: string; // User name (for display)
  needsRefilling?: boolean; // Whether refilling is needed
  noVisitPeriod?: string; // No visit period (when refilling is false): Q1, Q2, Q3, Q4
  dcDoc?: string; // Google Drive link (optional)
  createdAt: string; // ISO timestamp
  updatedAt: string; // ISO timestamp
  createdBy: string; // User ID
  createdByName?: string; // User name (for display)
}

export interface CreateAMCRequest {
  state: string;
  locationCode: string;
  oldLocationCode: string;
  visitPeriod: string;
  visitDate: string;
  reportNo: string;
  nextVisitDate: string;
  visitedBy: string;
  needsRefilling?: boolean; // Whether refilling is needed
  noVisitPeriod?: string; // No visit period (when refilling is false)
  dcDoc?: string;
}

export interface UpdateAMCRequest extends CreateAMCRequest {
  visitId: string;
}

export interface AMCFormData {
  state: string;
  locationCode: string;
  oldLocationCode: string;
  visitPeriod: string;
  visitDate: string;
  reportNo: string;
  nextVisitDate: string;
  visitedBy: string;
  needsRefilling?: boolean;
  noVisitPeriod?: string; // No visit period when refilling is false
  dcDoc: string;
}

// Dropdown options
export const VISIT_PERIOD_OPTIONS = [
  { value: "Q1", label: "Q1 (Jan-Mar)" },
  { value: "Q2", label: "Q2 (Apr-Jun)" },
  { value: "Q3", label: "Q3 (Jul-Sep)" },
  { value: "Q4", label: "Q4 (Oct-Dec)" },
];

export const STATE_OPTIONS = [
  { value: "tamilnadu", label: "Tamil Nadu" },
  { value: "karnataka", label: "Karnataka" },
  { value: "pondicherry", label: "Pondicherry" },
];
